import { Link, useLocation } from '@tanstack/react-router';
import { Pill, TIconImages } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import cn from 'classnames';

import styles from './AccountMenu.module.scss';

const MENU_ITEMS: {
  to: string;
  labelKey:
    | 'editProfile'
    | 'balance'
    | 'promocode'
    | 'achievements'
    | 'gameHistory';
  icon: TIconImages;
}[] = [
  { to: '/account/profile', labelKey: 'editProfile', icon: 'edit' },
  { to: '/account/balance', labelKey: 'balance', icon: 'coins' },
  { to: '/account/balance/promocode', labelKey: 'promocode', icon: 'coin' },
  { to: '/account/achievements', labelKey: 'achievements', icon: 'star' },
  { to: '/account/history', labelKey: 'gameHistory', icon: 'history' },
];

export const AccountMenu = ({
  className,
  onLinkClick,
}: {
  className?: string;
  onLinkClick?: () => void;
}) => {
  const location = useLocation();
  const { t } = useTranslation('layout');

  const isActive = (path: string) => {
    const normalize = (value: string) => value.replace(/\/+$/, '');
    const normalizedPathname = normalize(location.pathname);
    const normalizedPath = normalize(path);

    if (normalizedPathname === normalizedPath) {
      return true;
    }

    if (!normalizedPathname.startsWith(`${normalizedPath}/`)) {
      return false;
    }

    return !MENU_ITEMS.some((item) => {
      const otherPath = normalize(item.to);
      if (otherPath === normalizedPath) {
        return false;
      }
      if (!otherPath.startsWith(`${normalizedPath}/`)) {
        return false;
      }

      return (
        normalizedPathname === otherPath ||
        normalizedPathname.startsWith(`${otherPath}/`)
      );
    });
  };

  return (
    <nav className={cn(styles.menu, className)}>
      {MENU_ITEMS.map((item) => {
        const active = isActive(item.to);

        return (
          <Link
            className={cn(styles.item, active && styles.active)}
            key={item.to}
            onClick={onLinkClick}
            to={item.to}
          >
            <Pill
              color={active ? 'text' : 'contrast'}
              icon={item.icon}
              iconColor={active ? 'accent' : 'text'}
              size="m"
            >
              {t(`accountMenu.${item.labelKey}`)}
            </Pill>
          </Link>
        );
      })}
    </nav>
  );
};
